import { render, staticRenderFns } from "./TradeRequestDirectInformation.vue?vue&type=template&id=6d43c91d"
import script from "./TradeRequestDirectInformation.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirectInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports